import React, { useState,useEffect } from "react";
import Home from "components/Home.js";
import DataSelfieSurvey from "components/DataSelfieSurvey.js";
import "./App.css";
import { AmplifyAuthenticator, AmplifySignIn } from "@aws-amplify/ui-react";
import { AuthState, onAuthUIStateChange } from "@aws-amplify/ui-components";
import { DataStore } from "@aws-amplify/datastore";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";


function App() {
  const [authState, setAuthState] = useState();
  const [user, setUser] = useState();
  
  useEffect(() => {
    return onAuthUIStateChange( (nextAuthState, authData) => {
      console.log("HOME: nextAuthState, authData", nextAuthState, authData);
      setAuthState(nextAuthState);
      setUser(authData);
     
      // if (!authData) {
      //   console.log("user is not signed in...");
      //   //  DataStore.clear();
      // }
    });
  }, []);
  
  // console.log('rendering', (authState === AuthState.SignedIn && user!=null))
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <div className="App">
        <Switch>
          <Route path="/dataselfie/:school?">
            <DataSelfieSurvey />
          </Route>
          <Route path="/">
            {authState === AuthState.SignedIn && user ? (
              <Home/>
            ) : (
              <AmplifyAuthenticator usernameAlias="email">
                <AmplifySignIn slot="sign-in" hideSignUp={true}></AmplifySignIn>
              </AmplifyAuthenticator>
            )}
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;